/**
 * Simple analytics helper to log shop and route engagement
 */

export type AnalyticsEventType = 'view_profile' | 'nav_profile' | 'nav_route';

export async function logAnalyticsEvent(shopId: string, eventType: AnalyticsEventType, routeId?: string) {
    try {
        await fetch("/api/analytics/log", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ shopId, eventType, routeId })
        });
    } catch (error) {
        console.error("Failed to log analytics event:", error);
    }
}

export async function logRouteNavAnalytics(routeId: string, shopIds: string[]) {
    try {
        await fetch("/api/analytics/log-route-nav", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ routeId, shopIds })
        });
    } catch (error) {
        console.error("Failed to log route nav analytics:", error);
    }
}
